'use strict';

/**
 *
 * @name: NnModalsRun
 *
 */

function NnModalsRun(
  $rootScope,
  $timeout,
  $location,
  nnModalsService
  ) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /**
   *
   * @PUBLIC
   *
   */

  /**
   *
   * @PRIVATE
   *
   */

  /**
   *
   * @RUN
   *
   */

  $rootScope.$on('$stateChangeSuccess', function() {

    $timeout(() => {
      if(!$location.search().modal){
        nnModalsService.hideModal(null, false);
      }
    })
  });

  $rootScope.$on('$locationChangeSuccess', function() {

    $timeout(() => {
      if(!$location.search().modal){
        nnModalsService.hideModal(null, false);
      }

      if($location.search().search){
        nnModalsService.showModal('search');
      }
    })
  });
}

export default NnModalsRun;



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-modals.run.js